import { createAction } from "redux-starter-kit";
import { normalize } from "normalizr";
import { debounce } from "lodash";
import axios from "axios";

import { addEntities } from "../../entities";
import {
  QUERY_RELATIONSHIPS_REQUEST,
  QUERY_RELATIONSHIPS_SUCCESS,
  QUERY_RELATIONSHIPS_FAILURE
} from "../types";

const handleResponse = (
  response,
  dispatch,
  paymentProfileRelationship,
  id,
  limit,
  ordering,
  filters
) => {
  const data = normalize(response.results, [paymentProfileRelationship]);
  dispatch(addEntities(data.entities));
  dispatch(
    createAction(QUERY_RELATIONSHIPS_SUCCESS)({
      id,
      items: data.result,
      count: response.count,
      next: response.next,
      previous: response.previous,
      ordering,
      limit,
      filters
    })
  );
  return response;
};

const debounced = debounce(
  async (dispatch, schema, api, id, limit, ordering, filters) => {
    dispatch(
      createAction(QUERY_RELATIONSHIPS_REQUEST)({
        limit,
        filters,
        ordering
      })
    );
    const response = await api.groups.getPaymentProfileRelationships(
      id,
      limit,
      ordering,
      filters
    );
    handleResponse(
      response,
      dispatch,
      schema.paymentProfileRelationship,
      id,
      limit,
      ordering,
      filters
    );
  },
  1000,
  { trailing: true }
);

export const next = (id, link, limit, ordering, filters) => async (
  dispatch,
  getState,
  { schema }
) => {
  try {
    dispatch(
      createAction(QUERY_RELATIONSHIPS_REQUEST)({
        limit,
        ordering,
        filters
      })
    );

    const response = await axios.get(link);
    handleResponse(
      response.data,
      dispatch,
      schema.paymentProfileRelationship,
      id,
      limit,
      ordering,
      filters
    );
  } catch (err) {
    dispatch(createAction(QUERY_RELATIONSHIPS_FAILURE)(err));
    throw err;
  }
};

const queryRelationships = (
  id,
  limit = 20,
  ordering = "-created",
  filters = {}
) => async (dispatch, getState, { api, schema }) => {
  try {
    await debounced(dispatch, schema, api, id, limit, ordering, filters);
  } catch (err) {
    dispatch(createAction(QUERY_RELATIONSHIPS_FAILURE)(err));
    throw err;
  }
};

export default queryRelationships;
